import { useEffect, useRef, useState } from "react";
import DoctorsFilterSection from "../components/doctors-list/DoctorsFilterSection";
import FilteredDoctorsSection from "../components/doctors-list/FilteredDoctorsSection";
import axios from "axios";
import SortDrawer from "../components/doctors-list/SortDrawer";
import { useLocation } from "react-router-dom";

const DoctorsListPage = () => {
  const location = useLocation();
  const [doctors, setDoctors] = useState([]);
  const [filteredDoctors, setFilteredDoctors] = useState([]);
  const [specialties, setSpecialties] = useState([]);
  const [insurances, setInsurances] = useState([]);
  const [cities, setCities] = useState([]);
  const [selectedInsuranceId, setSelectedInsuranceId] = useState(0);
  const [selectedSpecialtyId, setSelectedSpecialtyId] = useState(0);
  const [selectedCity, setSelectedCity] = useState(0);
  const [loading, setLoading] = useState(true);
  const [totalItems, setTotalItems] = useState(20);
  const [numberFromChild, setNumberFromChild] = useState(1);
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedSpecialty, setSelectedSpecialty] = useState("همه");
  const [selectedCityy, setSelectedCityy] = useState("همه");
  const [activeFilter, setActiveFilter] = useState("");

  // استیت‌های مربوط به سرچ که به کامپوننت فیلتر پاس داده می‌شوند
  const [tempSearch, setTempSearch] = useState("");

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    setSearchQuery(tempSearch);
  };

  const filters = [
    { name: "highestScore", label: "بیشترین امتیاز" },
    { name: "mostSuccessfulConsultations", label: "بیشترین مشاوره موفق" },
  ];

  const filteredDoctorss = doctors
    .filter((d) => selectedSpecialty === "همه" || d.title === selectedSpecialty)
    .filter((d) => selectedCityy === "همه" || d.city_name === selectedCityy)
    .sort((a, b) => {
      if (activeFilter === "highestScore") return b.score - a.score;
      if (activeFilter === "mostSuccessfulConsultations")
        return b.count - a.count;
      return 0;
    });

  useEffect(() => {
    axios
      .get("https://medizenapi.ir/v1/category/getCategories")
      .then((res) => {
        if (res.data?.response_status === "success") {
          const list = [{ id: 0, title: "همه تخصص‌ها" }, ...res.data.data];
          setSpecialties(list);
        }
      })
      .catch((err) => console.error("❌ Specialities API Error:", err));
  }, []);

  useEffect(() => {
    axios
      .get("https://medizenapi.ir/v1/location/getCities?country_id=103")
      .then((res) => {
        if (res.data?.response_status === "success") {
          const list = [{ id: 0, name: "همه شهرها" }, ...res.data.data];
          setCities(list);
        }
      })
      .catch((err) => console.error("❌ Cities API Error:", err));
  }, []);

  useEffect(() => {
    axios
      .get("https://medizenapi.ir/v1/doctor/getInsurances")
      .then((res) => {
        if (res.data?.response_status === "success") {
          const list = [{ id: 0, title: "همه بیمه‌ها" }, ...res.data.data];
          setInsurances(list);
        }
      })
      .catch((err) => console.error("❌ Insurances API Error:", err));
  }, []);

  const controllerRef = useRef(null);

  const update_doctors = async (pageToFetch) => {
    if (controllerRef.current) {
      controllerRef.current.abort();
    }
    controllerRef.current = new AbortController();
    const signal = controllerRef.current.signal;

    setLoading(true);
    try {
      const params = new URLSearchParams();
      params.append("page", pageToFetch);
      params.append("count", 20);
      params.append("city_id", selectedCity);
      params.append("category_id", selectedSpecialtyId);
      params.append("insurance_id", selectedInsuranceId);
      params.append("search", searchQuery);
      const url = `https://medizenapi.ir/v1/doctor/getDoctors?${params.toString()}`;

      const res = await axios.get(url, { signal });

      if (res.data?.response_status === "success") {
        const newDoctors = res.data.data || [];
        setTotalItems(res.data.total || 0);
        setDoctors(newDoctors);
        setFilteredDoctors(newDoctors);
      } else {
        setDoctors([]);
        setFilteredDoctors([]);
        setTotalItems(0);
      }
    } catch (error) {
      if (error.name !== "AbortError") {
        console.error("❌ Doctors API Error:", error);
        setDoctors([]);
        setFilteredDoctors([]);
        setTotalItems(0);
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    setNumberFromChild(1);
  }, [selectedCity, selectedSpecialtyId, selectedInsuranceId, searchQuery]);

  useEffect(() => {
    update_doctors(numberFromChild);
  }, [
    numberFromChild,
    selectedCity,
    selectedSpecialtyId,
    selectedInsuranceId,
    searchQuery,
  ]);

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const cityParam = queryParams.get("city");
    const specialtyParam = queryParams.get("specialty");
    const searchParam = queryParams.get("search");

    if (searchParam) {
      setSearchQuery(searchParam);
      setTempSearch(searchParam);
    }

    if (cityParam && cities.length > 0) {
      const foundCity = cities.find((c) => c.name === cityParam);
      if (foundCity) setSelectedCity(foundCity.id);
    }

    if (specialtyParam && specialties.length > 0) {
      const foundSpecialty = specialties.find(
        (s) => s.title === specialtyParam,
      );
      if (foundSpecialty) setSelectedSpecialtyId(foundSpecialty.id);
    }
  }, [location.search, cities, specialties]);

  const handleDataFromChild = (number) => {
    setNumberFromChild(number);
  };
  useEffect(() => {
    // ۱. ذخیره کردن مقادیر اولیه برای بازگردانی در هنگام خروج از صفحه
    const originalHtmlOverflowX = document.documentElement.style.overflowX;
    const originalBodyOverflowX = document.body.style.overflowX;
    const originalHtmlOverflowY = document.documentElement.style.overflowY;
    const originalBodyOverflowY = document.body.style.overflowY;

    // ۲. اعمال استایل‌های جدید برای فعال شدن حالت Sticky در این صفحه
    document.documentElement.style.overflowX = "visible";
    document.body.style.overflowX = "visible";

    // اختیاری: اطمینان از اینکه سرریز عمودی روی visible است
    document.documentElement.style.overflowY = "visible";
    document.body.style.overflowY = "visible";

    // ۳. تابع Cleanup: بازگرداندن استایل‌ها به حالت اولیه وقتی کاربر صفحه را ترک می‌کند
    return () => {
      document.documentElement.style.overflowX = originalHtmlOverflowX;
      document.body.style.overflowX = originalBodyOverflowX;
      document.documentElement.style.overflowY = originalHtmlOverflowY;
      document.body.style.overflowY = originalBodyOverflowY;
    };
  }, []);

  return (
    <div className="w-full flex justify-center max-w-screen pb-[40px] lg:pb-[70px]">
      <div className="w-full md:w-[85%] flex flex-col lg:flex-row gap-6 max-md:mt-3 lg:-mt-0">
        {/* ستون کناری (Sticky) - فقط شامل کامپوننت فیلتر */}
        <div
          className="lg:w-4/12 xl:w-3/12 flex-shrink-0 h-fit lg:sticky 
          lg:top-[100px] lg:self-start z-10 lg:-mt-3"
        >
          <DoctorsFilterSection
            doctors={doctors}
            specialties={specialties}
            insurances={insurances}
            cities={cities}
            selectedSpecialtyId={selectedSpecialtyId}
            setSelectedSpecialtyId={setSelectedSpecialtyId}
            selectedCity={selectedCity}
            setSelectedCity={setSelectedCity}
            selectedInsuranceId={selectedInsuranceId}
            setSelectedInsuranceId={setSelectedInsuranceId}
            searchValue={searchQuery}
            update_doctors={update_doctors}
            // پراپ‌های جدید برای هندل کردن سرچ از داخل فیلتر
            tempSearch={tempSearch}
            setTempSearch={setTempSearch}
            handleSearchSubmit={handleSearchSubmit}
          />
        </div>

        {/* ستون اصلی لیست پزشکان */}
        <div className="flex flex-col w-full">
          <div className="w-full flex flex-col -mt-3">
            <div className="w-full flex justify-between items-center mb-4 bg-white p-4 rounded-2xl shadow-sm">
              <h2 className="w-full font-bold text-[17px] lg:text-[19px] text-black/80">
                لیست پزشکان
              </h2>
              <SortDrawer
                className={"w-[130px] md:w-[150px]"}
                filters={filters}
                activeFilter={activeFilter}
                setActiveFilter={setActiveFilter}
                defaultLabel="مرتب‌سازی"
              />
            </div>
          </div>
          <div className="flex-1">
            {loading ? (
              <div className="flex flex-col justify-center h-full items-center py-20">
                <div className="w-16 h-16 border-4 border-aqua-700 border-t-aqua rounded-full animate-spin "></div>
                <p className="mt-4 text-gray-700 font-medium">
                  در حال بارگذاری...
                </p>
              </div>
            ) : filteredDoctors.length === 0 ? (
              <div className="h-full flex items-center justify-center text-center text-gray-600">
                هیچ پزشکی یافت نشد.
              </div>
            ) : (
              <FilteredDoctorsSection
                doctors={filteredDoctors}
                totalItems={totalItems}
                onNumberPass={handleDataFromChild}
                setNumberFromChild={setNumberFromChild}
                numberFromChild={numberFromChild}
                filteredDoctors={filteredDoctors}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DoctorsListPage;
